// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Zjlv0a_ZyPl07fbhgBd6{margin-bottom:15px}.vMPW3C_pWgKwZvu8Tfv9>*{margin-bottom:26px}.vMPW3C_pWgKwZvu8Tfv9>*:last-child{margin-bottom:0}.d2ThNjGwcQ1F25ahNjvg{padding-bottom:6px}.d2ThNjGwcQ1F25ahNjvg:not(:last-child){border-bottom:1px solid #91a5bc}.xjQbKbR4bauKkEw21HAW{display:grid;grid-template-columns:repeat(2, 1fr);column-gap:10px;row-gap:10px}.SMw2F3XZ_aqn6FHlIJZr{font-size:14px;font-weight:500;color:#5b6473;margin-bottom:4px}.V82mXnaLNlbpcmxRNnTq{font-size:13px;color:#5b6473}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "Zjlv0a_ZyPl07fbhgBd6",
	"userData": "vMPW3C_pWgKwZvu8Tfv9",
	"dataBlock": "d2ThNjGwcQ1F25ahNjvg",
	"dataBlockTwoCol": "xjQbKbR4bauKkEw21HAW",
	"label": "SMw2F3XZ_aqn6FHlIJZr",
	"help": "V82mXnaLNlbpcmxRNnTq"
};
export default ___CSS_LOADER_EXPORT___;
